import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { EmploymentAccessService } from '../services/employment-access.service';

@Directive({ selector: '[pr-company-employee-employment-at-least-one-permission]', standalone: true })
export class CompanyEmployeeEmploymentAccessDirective implements OnInit {
  @Input('pr-company-employee-employment-at-least-one-permission') set setEmployeeId(employeeId: string) {
    this.employeeId = employeeId;
    this.updateView();
  }
  @Input('pr-company-employee-employment-at-least-one-permissionCompanyId') set setCompanyId(companyId: number) {
    this.companyId = Number(companyId);

    this.updateView();
  }
  @Input('pr-company-employee-employment-at-least-one-permissionPermissions') set setPermissions(permissions: string[]) {
    this.permissions = permissions;

    this.updateView();
  }
  @Input('pr-company-employee-employment-at-least-one-permissionOwnPermissions') set setOwnPermissions(ownPermissions: string[]) {
    this.ownPermissions = ownPermissions;

    this.updateView();
  }
  @Input('pr-company-employee-employment-at-least-one-permissionRequireAll') set setRequireAll(requireAll: boolean) {
    this.requireAll = requireAll;

    this.updateView();
  }

  private employeeId: string;
  private companyId: number;
  private permissions: string[] = [];
  private ownPermissions: string[] = [];
  private requireAll = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private employmentAccessService: EmploymentAccessService
  ) {}

  ngOnInit() {
    this.updateView();
  }

  private updateView() {
    this.viewContainerRef.clear();

    if (!this.employeeId || !this.companyId) {
      return;
    }

    if (!this.permissions?.length && !this.ownPermissions?.length) {
      return;
    }

    const hasAccessToAnyEmployment: boolean = this.employmentAccessService.hasAccessToAnyCompanyEmployeeEmployment(
      this.employeeId,
      this.companyId
    );

    if (!hasAccessToAnyEmployment) {
      return;
    }

    const anyEmploymentHasAccess: boolean = this.employmentAccessService.hasPermissionsAtLeastOneEmployeeEmployment(
      this.permissions,
      this.ownPermissions,
      this.companyId,
      this.employeeId,
      this.requireAll
    );

    if (!anyEmploymentHasAccess) {
      return;
    }

    this.viewContainerRef.createEmbeddedView(this.templateRef);
  }
}
